// extracted by mini-css-extract-plugin
module.exports = {"label_spec":"activityLog_label_spec__3QhnM","activity_log":"activityLog_activity_log__2u7Ea"};